module.exports = __webpack_public_path__ + "img/DE05750.60b813bd.png";